<template>
  <div v-if="getEntityStatusProps === 'PUBLISHED'">
    <span v-if="getEntityStatusProps === 'PUBLISHED'" class="statusEntity statusSuccess">Yayında</span>
  </div>

  <div v-else-if="getEntityStatusProps === pageNameCreate + ' | ' + 'DRAFT'" class="d-inline-flex">
    <span class="statusEntity statusPrimary">Tanımlama</span>
    <img
      v-b-tooltip="{
        customClass: 'tooltipContainer',
        trigger: 'hover',
        title: 'Taslak - Tanımlama',
        html: true,
        placement: 'top',
      }"
      src="../../../public/src/images/icon-awesome-edit-grey.svg"
      class="statusEditImg"
      alt="icon-awesome-edit-grey"
    />
  </div>

  <div v-else-if="getEntityStatusProps === pageNameCreate + ' | ' + 'WAITING_APPROVAL'" class="d-inline-flex">
    <span class="statusEntity statusPrimary">Tanımlama</span>
    <img
      v-b-tooltip="{
        customClass: 'tooltipContainer',
        trigger: 'hover',
        title: 'Onay Bekliyor - Tanımlama',
        html: true,
        placement: 'top',
      }"
      src="../../../public/src/images/icon-awesome-history-warning.svg"
      class="statusEditImg bgWarning"
      alt="icon-awesome-history-warning"
    />
  </div>

  <div v-else-if="getEntityStatusProps === pageNameUpdate + ' | ' + 'DRAFT'" class="d-inline-flex">
    <span class="statusEntity statusInfo">Güncelle</span>
    <img
      v-b-tooltip="{
        customClass: 'tooltipContainer',
        trigger: 'hover',
        title: 'Taslak - Güncelle',
        html: true,
        placement: 'top',
      }"
      src="../../../public/src/images/icon-awesome-edit-grey.svg"
      class="statusEditImg"
      alt="icon-awesome-edit-grey"
    />
  </div>

  <div v-else-if="getEntityStatusProps === pageNameUpdate + ' | ' + 'WAITING_APPROVAL'" class="d-inline-flex">
    <span class="statusEntity statusInfo">Güncelle</span>
    <img
      v-b-tooltip="{
        customClass: 'tooltipContainer',
        trigger: 'hover',
        title: 'Onay Bekliyor - Güncelle',
        html: true,
        placement: 'top',
      }"
      src="../../../public/src/images/icon-awesome-history-warning.svg"
      class="statusEditImg bgWarning"
      alt="icon-awesome-history-warning"
    />
  </div>

  <div v-else-if="getEntityStatusProps === pageNameDelete + ' | ' + 'WAITING_APPROVAL'" class="d-inline-flex">
    <span class="statusEntity statusDanger">Silme</span>
    <img
      v-b-tooltip="{
        customClass: 'tooltipContainer',
        trigger: 'hover',
        title: 'Onay Bekliyor - Silme',
        html: true,
        placement: 'top',
      }"
      src="../../../public/src/images/icon-awesome-history-warning.svg"
      class="statusEditImg bgWarning"
      alt="icon-awesome-history-warning"
    />
  </div>
</template>

<script>
export default {
  name: "EntityStatus",
  props: {
    getEntityStatusProps: {
      type: String,
      default: "PUBLISHED",
    },
    pageName: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      pageNameCreate: this.pageName.CREATE,
      pageNameUpdate: this.pageName.UPDATE,
      pageNameDelete: this.pageName.DELETE,
    };
  },
};
</script>

<style lang="scss" scoped>
.tooltipContainer {
  .tooltip-inner {
    text-align: left;
  }

  // `fade` ve `show` sınıfları yoksa koy
  &:not(.fade):not(.show) {
    opacity: 1;
    outline: 0;
    display: block;
  }
}
</style>
